<div class="post-card" [ngClass]="{
    'post-card--layout--grid': ['grid-nl', 'grid-lg'].includes(layout),
    'post-card--layout--list': ['list-nl', 'list-sm'].includes(layout),

    'post-card--size--nl': ['grid-nl', 'list-nl'].includes(layout),
    'post-card--size--lg': layout === 'grid-lg',
    'post-card--size--sm': layout === 'list-sm'
}"><!-- {{post|json}} -->
<div class="w-full text-center" >
    <div class="post-card__image">
        <a appClick [routerLink]="['/blog', post?.seo?.slug]">
            <img [src]="post.thumbImage?.url" alt="" loading="lazy" [alt]="translateHelper.localize(post.title)">
        </a>
    </div></div>
    <div class="post-card__info">
        <div class="post-card__category">
            <a appClick [routerLink]="['/blog', post?.seo?.slug]" *ngFor="let category of post.categories">{{ category }}</a>
        </div>
        <div class="post-card__name">
            <a appClick [routerLink]="['/blog', post?.seo?.slug]">{{ translateHelper.localize(post.title) }}</a>
        </div>
        <!-- <div class="post-card__date">{{ post.creationDate | date : 'medium' }}</div> -->
        <div class="post-header__meta-item">{{post.creatorData?.name}}</div>
        <div class="post-header__meta-item">{{ post.creationDate | date : 'mediumDate' }}</div>
        <div class="post-card__content h-24 overflow-hidden" [innerHTML]="translateHelper.localize(post?.shortArticle)"></div>

        <div class="post-card__read-more">
            <a appClick [routerLink]="['/blog', post?.seo?.slug]" class="btn btn-secondary btn-sm">{{"read_more" | translate}}</a>
        </div>
    </div>
</div>
